import {
    // Actions
    toggleSelector,

    // Selectors
    isOpen,
} from './data'

// Reducer is exposed so that we can hook up the state
export { default as profileSelectorReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// // Constants are exposed as a way for feature to send out information
// // Way for the feauture to inform the surroundings of something that has happened
// export const constants = {
// }

// Actions are exposed as a way for the feature to recieve information
// The surrounding can send in data using these actions
export const actions = {
    toggleSelector, // Users
}

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    isOpen, // App
}



// WEBPACK FOOTER //
// ./src/features/ProfileSelector/exports.js